import { CallToAction } from "../components/HomePage/CallToAction";
import { Faqs } from "../components/HomePage/Faqs";
import { Footer } from "../components/HomePage/Footer";
import { Header } from "../components/HomePage/Header";
import { Hero } from "../components/HomePage/Hero";
import { PrimaryFeatures } from "../components/HomePage/PrimaryFeatures";
import { SecondaryFeatures } from "../components/HomePage/SecondaryFeatures";
import { Features } from "../components/HomePage/Features";
import { Section } from "../components/HomePage/Section";

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <PrimaryFeatures />
        <SecondaryFeatures />
        <CallToAction />
        <Features />
        <Faqs />
        <Section />
      </main>
      <Footer />
    </>
  );
}
